// AUTO-GENERATED by scripts/gen-services-index.ts — do not edit by hand.
// Card-level service metadata (no longform bodies) for internal-linking components.
import type { ServiceId } from "@/data/services";

export type ServiceCardMeta = {
  id: ServiceId;
  slug: string;
  nameTh: string;
  nameEn: string;
  priceFrom: number;
  turnaround: string;
  relatedServiceIds: ServiceId[];
};

export const SERVICE_INDEX: Record<ServiceId, ServiceCardMeta> = {
 "translation": {
  "id": "translation",
  "slug": "translation",
  "nameTh": "บริการแปลและรับรองเอกสารทุกภาษาทั่วโลก",
  "nameEn": "Certified Translation Services (All Languages)",
  "priceFrom": 500,
  "turnaround": "เร่งด่วน 4 ชม. · มาตรฐาน 1–3 วัน",
  "relatedServiceIds": [
   "notary-public",
   "mfa-legalization",
   "embassy-legalization",
   "naati"
  ]
 },
 "notary-public": {
  "id": "notary-public",
  "slug": "notary-public",
  "nameTh": "บริการรับรองเอกสาร Notary Public โดยทนายความรับรองลายมือชื่อ",
  "nameEn": "Notary Public / Notarial Services Attorney",
  "priceFrom": 1500,
  "turnaround": "เสร็จในวันเดียว · เร่งด่วนภายใน 1 ชั่วโมง",
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "police-clearance"
  ]
 },
 "naati": {
  "id": "naati",
  "slug": "naati",
  "nameTh": "บริการแปลและรับรอง NAATI (Australia) — Online ทั่วโลก",
  "nameEn": "NAATI Certified Translation Australia (Online Worldwide)",
  "priceFrom": 1300,
  "turnaround": "1–3 วันทำการ · เร่งด่วน 24 ชม.",
  "relatedServiceIds": [
   "translation",
   "notary-public",
   "police-clearance",
   "embassy-legalization"
  ]
 },
 "police-clearance": {
  "id": "police-clearance",
  "slug": "police-clearance",
  "nameTh": "บริการขอตรวจสอบประวัติอาชญากรรม (Police Clearance) สำหรับคนไทย",
  "nameEn": "Police Clearance Certificate Service for Thai Nationals",
  "priceFrom": 2000,
  "turnaround": "ใช้ในไทย 3–7 วัน · ใช้ต่างประเทศ 7–14 วัน",
  "relatedServiceIds": [
   "translation",
   "naati",
   "mfa-legalization",
   "embassy-legalization"
  ]
 },
 "mfa-legalization": {
  "id": "mfa-legalization",
  "slug": "mfa-legalization",
  "nameTh": "บริการรับรองเอกสารกงสุลไทย กระทรวงการต่างประเทศ (MFA · นิติกรณ์ไทย)",
  "nameEn": "MFA / Consular Legalization (Thai Ministry of Foreign Affairs)",
  "priceFrom": 2500,
  "turnaround": "ปกติ 3 วันทำการ · เร่งด่วน 1 วัน",
  "relatedServiceIds": [
   "embassy-legalization",
   "translation",
   "notary-public",
   "police-clearance"
  ]
 },
 "embassy-legalization": {
  "id": "embassy-legalization",
  "slug": "embassy-legalization",
  "nameTh": "บริการรับรองเอกสารโดยสถานทูตทุกประเทศทั่วโลก",
  "nameEn": "Embassy Legalization Service (All Embassies Worldwide)",
  "priceFrom": 5000,
  "turnaround": "3–14 วันทำการ ขึ้นกับสถานทูต",
  "relatedServiceIds": [
   "mfa-legalization",
   "translation",
   "notary-public",
   "police-clearance"
  ]
 },
 "visa-thai-citizens": {
  "id": "visa-thai-citizens",
  "slug": "visa-thai-citizens",
  "nameTh": "บริการให้คำปรึกษาและยื่นวีซ่าทั่วโลกสำหรับคนไทย",
  "nameEn": "Global Visa Application & Consulting for Thai Citizens",
  "priceFrom": 3500,
  "turnaround": "ปรึกษาทันที · เตรียมเอกสาร 3–7 วัน · ตามคิวสถานทูต",
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "police-clearance"
  ]
 },
 "visa-foreigners-thailand": {
  "id": "visa-foreigners-thailand",
  "slug": "visa-foreigners-thailand",
  "nameTh": "บริการวีซ่า & Work Permit สำหรับชาวต่างชาติในประเทศไทย",
  "nameEn": "Thailand Visa & Work Permit Service for Foreigners",
  "priceFrom": 4500,
  "turnaround": "Consultation same day · Document prep 3–7 days · Immigration queue dependent",
  "relatedServiceIds": [
   "translation",
   "notary-public",
   "embassy-legalization",
   "mfa-legalization"
  ]
 },
 "marriage-thai-foreign": {
  "id": "marriage-thai-foreign",
  "slug": "marriage-thai-foreign",
  "nameTh": "บริการจดทะเบียนสมรสไทย–ต่างชาติครบวงจร",
  "nameEn": "Thai-Foreign Marriage Registration Service (End-to-End)",
  "priceFrom": 4500,
  "turnaround": "Affidavit 1–3 วัน · ครบทุกขั้นตอน 7–14 วัน",
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "visa-thai-citizens"
  ]
 },
 "interpreter": {
  "id": "interpreter",
  "slug": "interpreter",
  "nameTh": "บริการล่ามแปลภาษา (ศาล · ตม. · ธุรกิจ · การแพทย์)",
  "nameEn": "Professional Interpreter Service (Court · Immigration · Business · Medical)",
  "priceFrom": 2500,
  "turnaround": "จัดล่ามได้ใน 4–24 ชั่วโมง",
  "relatedServiceIds": [
   "translation",
   "marriage-thai-foreign",
   "notary-public",
   "visa-foreigners-thailand"
  ]
 },
 "apec-abtc": {
  "id": "apec-abtc",
  "slug": "apec-business-travel-card",
  "nameTh": "บริการขอบัตรเดินทาง APEC Business Travel Card (ABTC)",
  "nameEn": "APEC Business Travel Card (ABTC) Application Service",
  "priceFrom": 12000,
  "turnaround": "ดำเนินการ 3–6 เดือน (รวม pre-clearance 19 เขต)",
  "relatedServiceIds": [
   "visa-thai-citizens",
   "mfa-legalization",
   "notary-public",
   "translation"
  ]
 },
 "apostille": {
  "id": "apostille",
  "slug": "apostille",
  "nameTh": "บริการรับรองเอกสาร Apostille (ไทยเข้าร่วม Hague Convention)",
  "nameEn": "Apostille Certification Service Thailand",
  "priceFrom": 2500,
  "turnaround": "เร่งด่วน 1 วัน · มาตรฐาน 3–5 วันทำการ",
  "relatedServiceIds": [
   "mfa-legalization",
   "embassy-legalization",
   "translation",
   "notary-public"
  ]
 },
 "tm30-90day": {
  "id": "tm30-90day",
  "slug": "tm30-90day-report",
  "nameTh": "บริการแจ้ง TM30 และรายงานตัว 90 วัน (Immigration Reporting)",
  "nameEn": "TM30 & 90-Day Report Immigration Service",
  "priceFrom": 900,
  "turnaround": "ยื่นออนไลน์ 24 ชม. · ที่ ตม. 1–2 วันทำการ",
  "relatedServiceIds": [
   "visa-foreigners-thailand",
   "marriage-thai-foreign",
   "translation",
   "notary-public"
  ]
 },
 "work-permit-boi": {
  "id": "work-permit-boi",
  "slug": "work-permit-boi-single-window",
  "nameTh": "บริการขอใบอนุญาตทำงาน Work Permit + BOI Single Window",
  "nameEn": "Work Permit + BOI Single Window Service",
  "priceFrom": 15000,
  "turnaround": "BOI Single Window 3 ชม. · DOE 7–10 วันทำการ",
  "relatedServiceIds": [
   "visa-foreigners-thailand",
   "tm30-90day",
   "translation",
   "mfa-legalization"
  ]
 },
 "permanent-residence": {
  "id": "permanent-residence",
  "slug": "permanent-residence-thailand",
  "nameTh": "บริการขอใบสำคัญถิ่นที่อยู่ (Permanent Residence) ในประเทศไทย",
  "nameEn": "Thai Permanent Residence (PR) Application Service",
  "priceFrom": 150000,
  "turnaround": "12–24 เดือน (ตามรอบ Quota ตม. ปกติเปิดปลายปี ต.ค.–ธ.ค.)",
  "relatedServiceIds": [
   "work-permit-boi",
   "visa-foreigners-thailand",
   "marriage-thai-foreign",
   "police-clearance"
  ]
 },
 "thai-citizenship": {
  "id": "thai-citizenship",
  "slug": "thai-citizenship",
  "nameTh": "บริการขอสัญชาติไทย (Thai Citizenship / Naturalization)",
  "nameEn": "Thai Citizenship & Naturalization Service",
  "priceFrom": 250000,
  "turnaround": "2–5 ปี (มท. + ครม. + ราชกิจจานุเบกษา)",
  "relatedServiceIds": [
   "permanent-residence",
   "marriage-thai-foreign",
   "translation",
   "mfa-legalization"
  ]
 },
 "company-boi": {
  "id": "company-boi",
  "slug": "company-boi",
  "nameTh": "บริการจดทะเบียนบริษัท + BOI Promotion ครบวงจร",
  "nameEn": "Company Registration & BOI Promotion Service",
  "priceFrom": 35000,
  "turnaround": "5–7 วัน (DBD) · 60–120 วัน (BOI) · 30–60 วัน (FBL/LTR)",
  "relatedServiceIds": [
   "work-permit-boi",
   "visa-foreigners-thailand",
   "translation",
   "mfa-legalization"
  ]
 },
 "trademark-ip": {
  "id": "trademark-ip",
  "slug": "trademark-ip",
  "nameTh": "บริการจดทะเบียนเครื่องหมายการค้า + ทรัพย์สินทางปัญญาครบวงจร",
  "nameEn": "Trademark Registration & Intellectual Property Service",
  "priceFrom": 8500,
  "turnaround": "10–14 เดือน (จดทะเบียน) · ตรวจค้น 1–2 วัน · ยื่น 1 สัปดาห์",
  "relatedServiceIds": [
   "company-boi",
   "notary-public",
   "translation",
   "mfa-legalization"
  ]
 },
 "sworn-translation": {
  "id": "sworn-translation",
  "slug": "sworn-translation",
  "nameTh": "บริการแปลรับรองโดยทนาย/ศาล + ล่ามศาล (Sworn Translation & Court Interpreter)",
  "nameEn": "Sworn Translation & Court Interpreter Service",
  "priceFrom": 1500,
  "turnaround": "1–3 วัน (แปล) · นัดล่ามล่วงหน้า 3–7 วัน · ฉุกเฉิน 24 ชม.",
  "relatedServiceIds": [
   "translation",
   "notary-public",
   "mfa-legalization",
   "trademark-ip"
  ]
 },
 "criminal-defense": {
  "id": "criminal-defense",
  "slug": "criminal-defense",
  "nameTh": "ทนายอาญา + คดียาเสพติด + ประกันตัว (Criminal Defense & Bail)",
  "nameEn": "Criminal Defense, Drug Cases & Bail Services",
  "priceFrom": 15000,
  "turnaround": "ฉุกเฉิน 24 ชม. · ประกันตัว 2–6 ชม. · คดีเต็มรูปแบบ 6–18 เดือน",
  "relatedServiceIds": [
   "sworn-translation",
   "visa-foreigners-thailand",
   "notary-public",
   "trademark-ip"
  ]
 },
 "civil-family-probate": {
  "id": "civil-family-probate",
  "slug": "civil-family-probate",
  "nameTh": "ทนายแพ่ง · ครอบครัว · หย่า · มรดก (Civil Litigation, Family Law, Divorce, Probate)",
  "nameEn": "Civil Litigation, Family Law, Divorce & Probate Services",
  "priceFrom": 8500,
  "turnaround": "หย่ายินยอม 1–3 วัน · ฟ้องหย่า/มรดก 4–14 เดือน · Prenup 5–10 วัน",
  "relatedServiceIds": [
   "sworn-translation",
   "criminal-defense",
   "notary-public",
   "marriage-thai-foreign"
  ]
 },
 "real-estate-conveyancing": {
  "id": "real-estate-conveyancing",
  "slug": "real-estate-conveyancing",
  "nameTh": "นิติกรรมที่ดิน · โอนกรรมสิทธิ์ · Real Estate Conveyancing",
  "nameEn": "Real Estate Conveyancing & Land Transactions",
  "priceFrom": 15000,
  "turnaround": "1–14 วันทำการ (Due Diligence 5–10 วัน · โอนกรรมสิทธิ์ 1 วัน)",
  "relatedServiceIds": [
   "civil-family-probate",
   "notary-public",
   "company-boi",
   "marriage-thai-foreign"
  ]
 },
 "tax-law": {
  "id": "tax-law",
  "slug": "tax-law",
  "nameTh": "กฎหมายภาษีอากร · PIT · CIT · VAT · Transfer Pricing",
  "nameEn": "Tax Law · PIT/CIT/VAT Compliance + Transfer Pricing",
  "priceFrom": 15000,
  "turnaround": "1–30 วันทำการ (Consult 1 วัน · Tax Return 3–7 วัน · Tax Audit Defense 30–180 วัน)",
  "relatedServiceIds": [
   "company-boi",
   "real-estate-conveyancing",
   "civil-family-probate",
   "trademark-ip"
  ]
 },
 "labor-employment": {
  "id": "labor-employment",
  "slug": "labor-employment",
  "nameTh": "กฎหมายแรงงาน · เลิกจ้าง · Severance · ศาลแรงงาน",
  "nameEn": "Labor Law & Employment · Severance · Labor Court · Workplace Investigation",
  "priceFrom": 9500,
  "turnaround": "1–30 วันทำการ (Consult 1 วัน · เลิกจ้าง 7 วัน · ศาลแรงงาน 60–180 วัน)",
  "relatedServiceIds": [
   "company-boi",
   "tax-law",
   "civil-family-probate",
   "criminal-defense"
  ]
 },
 "banking-finance": {
  "id": "banking-finance",
  "slug": "banking-finance",
  "nameTh": "กฎหมายธนาคารและการเงิน · NPL · Debt Restructuring · Securities · SEC",
  "nameEn": "Banking & Finance Law · NPL · Debt Restructuring · Securities · SEC Compliance",
  "priceFrom": 12000,
  "turnaround": "1–365 วัน (ปรึกษา 1 วัน · NPL Suit 30 วัน · Restructuring 90-180 วัน · IPO 12-18 เดือน)",
  "relatedServiceIds": [
   "company-boi",
   "tax-law",
   "real-estate-conveyancing",
   "civil-family-probate"
  ]
 },
 "pdpa-cybersecurity": {
  "id": "pdpa-cybersecurity",
  "slug": "pdpa-cybersecurity",
  "nameTh": "PDPA · Cybersecurity · กฎหมายคุ้มครองข้อมูลส่วนบุคคล",
  "nameEn": "PDPA & Cybersecurity Law · Data Protection · Cyber Incident Response",
  "priceFrom": 9500,
  "turnaround": "1–180 วัน (ปรึกษา 1 วัน · Gap Assessment 7-14 วัน · Full Implementation 60-180 วัน · Breach Response 4 ชม.)",
  "relatedServiceIds": [
   "company-boi",
   "banking-finance",
   "trademark-ip",
   "criminal-defense"
  ]
 },
 "international-arbitration": {
  "id": "international-arbitration",
  "slug": "international-arbitration",
  "nameTh": "อนุญาโตตุลาการระหว่างประเทศ · International Arbitration · Cross-border Dispute",
  "nameEn": "International Arbitration & Cross-border Dispute Resolution",
  "priceFrom": 85000,
  "turnaround": "30 วัน – 36 เดือน (Emergency Arbitrator 15 วัน · Expedited 6 เดือน · Full Arbitration 12-24 เดือน · ICSID 24-48 เดือน)",
  "relatedServiceIds": [
   "banking-finance",
   "company-boi",
   "labor-employment",
   "civil-family-probate"
  ]
 },
 "ltr-elite-visa": {
  "id": "ltr-elite-visa",
  "slug": "ltr-elite-visa",
  "nameTh": "LTR Visa · Thailand Privilege (Elite) · BOI Smart Visa · Immigration ครบวงจร",
  "nameEn": "LTR Visa, Thailand Privilege (Elite), BOI Smart Visa & Immigration",
  "priceFrom": 18000,
  "turnaround": "LTR 60-90 วัน · Elite 30-45 วัน · Smart Visa 30-60 วัน · PR 12-36 เดือน",
  "relatedServiceIds": [
   "visa-foreigners-thailand",
   "work-permit-boi",
   "permanent-residence",
   "thai-citizenship"
  ]
 },
 "ma-private-equity": {
  "id": "ma-private-equity",
  "slug": "ma-private-equity",
  "nameTh": "M&A · Private Equity · Venture Capital · Corporate Finance ครบวงจร",
  "nameEn": "M&A, Private Equity, Venture Capital & Corporate Finance",
  "priceFrom": 35000,
  "turnaround": "Term Sheet 7-14 วัน · DD 4-8 สัปดาห์ · Signing-to-Closing 8-24 สัปดาห์",
  "relatedServiceIds": [
   "banking-finance",
   "tax-law",
   "international-arbitration",
   "company-boi",
   "trademark-ip",
   "pdpa-cybersecurity"
  ]
 },
 "work-experience-certificate": {
  "id": "work-experience-certificate",
  "slug": "work-experience-certificate",
  "nameTh": "บริการขอใบรับรองประสบการณ์ทำงาน (ประกันสังคม · กระทรวงแรงงาน · แปล · กงสุล · สถานทูต)",
  "nameEn": "Work Experience Certificate Service — SSO, Ministry of Labour, Translation & Legalization",
  "priceFrom": 2500,
  "turnaround": "เร่งด่วน 3 วัน · มาตรฐาน 7–14 วันทำการ",
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "notary-public",
   "visa-thai-citizens",
   "apec-abtc"
  ]
 },
 "medical-council-certification": {
  "id": "medical-council-certification",
  "slug": "medical-council-certification",
  "nameTh": "บริการรับรองเอกสารโดยแพทยสภา (Good Standing · ใบประกอบวิชาชีพ · Specialist Certificate)",
  "nameEn": "Medical Council Certification Service — Good Standing, Medical License & Specialist Verification",
  "priceFrom": 4500,
  "turnaround": "เร่งด่วน 5 วัน · มาตรฐาน 14–21 วันทำการ",
  "relatedServiceIds": [
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "notary-public",
   "sworn-translation",
   "naati"
  ]
 },
 "notary-public-foreigners": {
  "id": "notary-public-foreigners",
  "slug": "notary-public-foreigners",
  "nameTh": "Notary Public บริการรับรองเอกสารสำหรับชาวต่างชาติในประเทศไทย",
  "nameEn": "Notary Public Service for Foreigners in Thailand — English-Speaking Notarial Services Attorney",
  "priceFrom": 1500,
  "turnaround": "Same-day · 1–3 business days (with legalisation)",
  "relatedServiceIds": [
   "notary-public",
   "mfa-legalization-foreigners",
   "translation",
   "embassy-legalization",
   "marriage-thai-foreign",
   "real-estate-conveyancing"
  ]
 },
 "mfa-legalization-foreigners": {
  "id": "mfa-legalization-foreigners",
  "slug": "mfa-legalization-foreigners",
  "nameTh": "MFA Legalisation Service for Foreigners — Thai Consular Authentication (English Service)",
  "nameEn": "MFA / Consular Legalisation Service for Foreigners in Thailand",
  "priceFrom": 3500,
  "turnaround": "Express 2 days · Standard 5–10 business days",
  "relatedServiceIds": [
   "mfa-legalization",
   "notary-public-foreigners",
   "translation",
   "embassy-legalization",
   "embassy-legalization-by-country",
   "police-clearance"
  ]
 },
 "marriage-abroad-thai": {
  "id": "marriage-abroad-thai",
  "slug": "marriage-abroad-thai",
  "nameTh": "บริการจดทะเบียนสมรสในต่างประเทศสำหรับคนไทย (USA, UK, Australia, Germany, Japan, China และอีก 40+ ประเทศ)",
  "nameEn": "Marriage Abroad — Document & Legalisation Service for Thai Citizens (40+ Countries)",
  "priceFrom": 6500,
  "turnaround": "Express 7 days · Standard 14–21 business days",
  "relatedServiceIds": [
   "marriage-thai-foreign",
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "visa-thai-citizens",
   "notary-public"
  ]
 },
 "naati-online-worldwide": {
  "id": "naati-online-worldwide",
  "slug": "naati-online-worldwide",
  "nameTh": "NAATI Certified Translation บริการแปล NAATI ออนไลน์ทั่วโลก (Australia, NZ, Worldwide)",
  "nameEn": "NAATI Certified Translation Online — Worldwide Service",
  "priceFrom": 850,
  "turnaround": "Standard 24–48h · Express 6–12h",
  "relatedServiceIds": [
   "naati",
   "translation",
   "sworn-translation",
   "visa-thai-citizens",
   "work-experience-certificate",
   "medical-council-certification"
  ]
 },
 "government-document-translation": {
  "id": "government-document-translation",
  "slug": "government-document-translation",
  "nameTh": "บริการแปลเอกสารราชการไทย ครบทุกประเภท (ทะเบียนราษฎร์ · ทะเบียนบ้าน · โฉนด · ทะเบียนบริษัท · คำพิพากษา)",
  "nameEn": "Thai Government Document Translation Service — Civil Registry, Property, Corporate, Court",
  "priceFrom": 500,
  "turnaround": "เร่งด่วน 1 วัน · มาตรฐาน 1–3 วันทำการ",
  "relatedServiceIds": [
   "translation",
   "sworn-translation",
   "government-document-certification",
   "mfa-legalization",
   "notary-public",
   "embassy-legalization"
  ]
 },
 "government-document-certification": {
  "id": "government-document-certification",
  "slug": "government-document-certification",
  "nameTh": "บริการขอและรับรองเอกสารราชการไทย (ทะเบียนราษฎร์ · กรมที่ดิน · DBD · ศาล)",
  "nameEn": "Thai Government Document Procurement & Certification Service",
  "priceFrom": 2500,
  "turnaround": "เร่งด่วน 1–3 วัน · มาตรฐาน 5–10 วันทำการ",
  "relatedServiceIds": [
   "government-document-translation",
   "translation",
   "mfa-legalization",
   "embassy-legalization",
   "notary-public",
   "marriage-abroad-thai"
  ]
 },
 "embassy-legalization-by-country": {
  "id": "embassy-legalization-by-country",
  "slug": "embassy-legalization-by-country",
  "nameTh": "บริการรับรองเอกสารโดยสถานทูต 30+ ประเทศในกรุงเทพฯ (USA, UK, EU, GCC, Asia)",
  "nameEn": "Embassy Legalisation Service — 30+ Embassies in Bangkok",
  "priceFrom": 5000,
  "turnaround": "5–15 business days (depends on embassy)",
  "relatedServiceIds": [
   "embassy-legalization",
   "mfa-legalization",
   "mfa-legalization-foreigners",
   "translation",
   "marriage-abroad-thai",
   "notary-public-foreigners"
  ]
 }
} as Record<ServiceId, ServiceCardMeta>;
